import { CSSProperties, HTMLProps, ReactNode } from 'react';

import './style.less';

export interface ContentWrapperProps extends HTMLProps<HTMLDivElement> {
  children?: ReactNode;
  extra?: ReactNode;
  extraStyle?: CSSProperties;
}

function ContentWrapper({
  children,
  extraStyle,
  extra = null,
  ...rest
}: ContentWrapperProps) {
  return (
    <div {...rest} className={`page-content-wrapper ${rest.className}`}>
      {extra ? (
        <div className="extra" style={extraStyle}>
          {extra}
        </div>
      ) : null}
      {children}
    </div>
  );
}

export default ContentWrapper;
